// Accountant view (BRIEF.md section 1): accounting words are allowed here and only here.
import type { Api } from '../api.js';
import { ChartOfAccounts } from './ChartOfAccounts.js';
import { Journals } from './Journals.js';
import { OpeningBalances } from './OpeningBalances.js';
import { Tracking } from './Tracking.js';
import { TrialBalance } from './TrialBalance.js';
import { XeroComparison } from './XeroComparison.js';

export const ACCOUNTANT_TABS = [
  ['journals', 'Journals'],
  ['accounts', 'Chart of accounts'],
  ['trial-balance', 'Trial balance'],
  ['tracking', 'Tracking'],
  ['opening', 'Opening balances'],
  ['xero', 'Xero comparison'],
] as const;

export type AccountantTab = (typeof ACCOUNTANT_TABS)[number][0];

export function AccountantScreen({
  tab,
  api,
  orgId,
}: {
  tab: AccountantTab;
  api: Api;
  orgId: string;
}) {
  switch (tab) {
    case 'journals':
      return <Journals api={api} orgId={orgId} />;
    case 'accounts':
      return <ChartOfAccounts api={api} orgId={orgId} />;
    case 'trial-balance':
      return <TrialBalance api={api} orgId={orgId} />;
    case 'tracking':
      return <Tracking api={api} orgId={orgId} />;
    case 'opening':
      return <OpeningBalances api={api} orgId={orgId} />;
    case 'xero':
      return <XeroComparison api={api} orgId={orgId} />;
  }
}
